<template>
  <div v-if="activeCard" class="min-w-0">
    <!-- Promo card -->
    <div class="relative overflow-hidden rounded-lg border border-gray-200 bg-gray-50 p-3 dark:border-slate-700 dark:bg-slate-900">
      <!-- Dismiss button -->
      <button
        class="absolute right-2 top-2 rounded p-0.5 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-600 dark:hover:bg-slate-700 dark:hover:text-gray-300"
        title="Dismiss"
        @click="dismiss(activeCard.id)"
      >
        <XMarkIcon class="h-3.5 w-3.5" />
      </button>

      <!-- Survey card -->
      <template v-if="activeCard.isSurvey">
        <div class="pr-5 text-xs font-semibold text-gray-700 dark:text-gray-200">
          {{ activeCard.title }}
        </div>
        <div class="mt-1 text-[11px] leading-relaxed text-gray-500 dark:text-gray-400">
          {{ activeCard.description }}
        </div>
        <div class="mt-2.5 space-y-1.5">
          <label
            v-for="option in surveyOptions"
            :key="option.value"
            class="flex cursor-pointer items-center gap-2 rounded px-2 py-1 text-[11px] transition-colors hover:bg-gray-100 dark:hover:bg-slate-800"
            :class="surveyAnswer === option.value ? 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/20 dark:text-indigo-300' : 'text-gray-600 dark:text-gray-400'"
          >
            <input
              v-model="surveyAnswer"
              type="radio"
              name="attribution"
              :value="option.value"
              class="h-3 w-3 text-indigo-600 focus:ring-indigo-500"
            >
            {{ option.label }}
          </label>
        </div>
        <button
          v-if="surveyAnswer"
          class="mt-2 w-full rounded bg-indigo-600 px-2 py-1 text-[11px] font-medium text-white transition-colors hover:bg-indigo-500"
          @click="submitSurvey(surveyAnswer)"
        >
          Submit
        </button>
      </template>

      <!-- Standard card (link or route) -->
      <template v-else>
        <div class="pr-5 text-xs font-semibold text-gray-700 dark:text-gray-200">
          {{ activeCard.title }}
        </div>
        <div class="mt-1 text-[11px] leading-relaxed text-gray-500 dark:text-gray-400">
          {{ activeCard.description }}
        </div>
        <div v-if="activeCard.cta && (activeCard.href || activeCard.routeTo)" class="mt-2.5">
          <a
            v-if="activeCard.href"
            :href="activeCard.href"
            target="_blank"
            class="inline-block text-[11px] font-semibold text-indigo-600 transition-colors hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300"
          >
            {{ activeCard.cta }} &rarr;
          </a>
          <router-link
            v-else-if="activeCard.routeTo"
            :to="{
              ...activeCard.routeTo,
              params: {
                ...activeCard.routeTo.params,
                teamPid: route.params.teamPid
              }
            }"
            class="inline-block text-[11px] font-semibold text-indigo-600 transition-colors hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300"
          >
            {{ activeCard.cta }} &rarr;
          </router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'

const route = useRoute()
const { activeCard, dismiss, submitSurvey, surveyAnswer } = useSidebarPromo()

const surveyOptions = computed(() => activeCard.value?.surveyOptions ?? [])
</script>
